// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { batchCheckAssistantScopesRequestToJson, batchCheckAssistantScopesResponseFromJson, buildDefaultAssistantRequestToJson, buildDefaultAssistantResponseFromJson, createAssistantRequestToJson, createAssistantResponseFromJson, deleteAssistantRequestToJson, executeFunctionRequestToJson, executeFunctionResponseFromJson, generateChatAnswerRequestToJson, generateChatAnswerResponseFromJson, getAssistantRequestToJson, getAssistantResponseFromJson, getAssistantTypeStatusRequestToJson, getAssistantTypeStatusResponseFromJson, getChatAnswerFunctionExecutionJobRequestToJson, getChatAnswerFunctionExecutionJobResponseFromJson, getMultiAssistantRequestToJson, getMultiAssistantResponseFromJson, listAllAssistantsAssociatedToConnectionRequestToJson, listAllAssistantsAssociatedToConnectionResponseFromJson, listAssistantRequestToJson, listAssistantResponseFromJson, listAvailableModelsRequestToJson, listAvailableModelsResponseFromJson, listTemplateVariablesRequestToJson, listTemplateVariablesResponseFromJson, setAssistantConnectionsRequestToJson, updateAssistantRequestToJson, upsertAssistantRequestToJson, upsertAssistantResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function upsertAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/UpsertAssistant', upsertAssistantRequestToJson(request));
    return upsertAssistantResponseFromJson(raw);
}
export function upsertAssistant$(request, options) {
    return defer(() => upsertAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function upsertAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/UpsertAssistant', upsertAssistantRequestToJson(request), options)
        .pipe(map(resp => upsertAssistantResponseFromJson(resp)));
}
export async function createAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/CreateAssistant', createAssistantRequestToJson(request));
    return createAssistantResponseFromJson(raw);
}
export function createAssistant$(request, options) {
    return defer(() => createAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function createAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/CreateAssistant', createAssistantRequestToJson(request), options)
        .pipe(map(resp => createAssistantResponseFromJson(resp)));
}
export async function updateAssistant(request) {
    await fetchRpc('ai_assistants.v1alpha1.AssistantService/UpdateAssistant', updateAssistantRequestToJson(request));
}
export function updateAssistant$(request, options) {
    return defer(() => updateAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function updateAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/UpdateAssistant', updateAssistantRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/GetAssistant', getAssistantRequestToJson(request));
    return getAssistantResponseFromJson(raw);
}
export function getAssistant$(request, options) {
    return defer(() => getAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function getAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/GetAssistant', getAssistantRequestToJson(request), options)
        .pipe(map(resp => getAssistantResponseFromJson(resp)));
}
export async function getMultiAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/GetMultiAssistant', getMultiAssistantRequestToJson(request));
    return getMultiAssistantResponseFromJson(raw);
}
export function getMultiAssistant$(request, options) {
    return defer(() => getMultiAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/GetMultiAssistant', getMultiAssistantRequestToJson(request), options)
        .pipe(map(resp => getMultiAssistantResponseFromJson(resp)));
}
export async function batchCheckAssistantScopes(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/BatchCheckAssistantScopes', batchCheckAssistantScopesRequestToJson(request));
    return batchCheckAssistantScopesResponseFromJson(raw);
}
export function batchCheckAssistantScopes$(request, options) {
    return defer(() => batchCheckAssistantScopesWithTransport$(getGlobalTransport(), request, options));
}
export function batchCheckAssistantScopesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/BatchCheckAssistantScopes', batchCheckAssistantScopesRequestToJson(request), options)
        .pipe(map(resp => batchCheckAssistantScopesResponseFromJson(resp)));
}
export async function buildDefaultAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/BuildDefaultAssistant', buildDefaultAssistantRequestToJson(request));
    return buildDefaultAssistantResponseFromJson(raw);
}
export function buildDefaultAssistant$(request, options) {
    return defer(() => buildDefaultAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function buildDefaultAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/BuildDefaultAssistant', buildDefaultAssistantRequestToJson(request), options)
        .pipe(map(resp => buildDefaultAssistantResponseFromJson(resp)));
}
export async function deleteAssistant(request) {
    await fetchRpc('ai_assistants.v1alpha1.AssistantService/DeleteAssistant', deleteAssistantRequestToJson(request));
}
export function deleteAssistant$(request, options) {
    return defer(() => deleteAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function deleteAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/DeleteAssistant', deleteAssistantRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listAssistant(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/ListAssistant', listAssistantRequestToJson(request));
    return listAssistantResponseFromJson(raw);
}
export function listAssistant$(request, options) {
    return defer(() => listAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function listAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/ListAssistant', listAssistantRequestToJson(request), options)
        .pipe(map(resp => listAssistantResponseFromJson(resp)));
}
export async function listAllAssistantsAssociatedToConnection(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/ListAllAssistantsAssociatedToConnection', listAllAssistantsAssociatedToConnectionRequestToJson(request));
    return listAllAssistantsAssociatedToConnectionResponseFromJson(raw);
}
export function listAllAssistantsAssociatedToConnection$(request, options) {
    return defer(() => listAllAssistantsAssociatedToConnectionWithTransport$(getGlobalTransport(), request, options));
}
export function listAllAssistantsAssociatedToConnectionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/ListAllAssistantsAssociatedToConnection', listAllAssistantsAssociatedToConnectionRequestToJson(request), options)
        .pipe(map(resp => listAllAssistantsAssociatedToConnectionResponseFromJson(resp)));
}
export async function generateChatAnswer(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/GenerateChatAnswer', generateChatAnswerRequestToJson(request));
    return generateChatAnswerResponseFromJson(raw);
}
export function generateChatAnswer$(request, options) {
    return defer(() => generateChatAnswerWithTransport$(getGlobalTransport(), request, options));
}
export function generateChatAnswerWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/GenerateChatAnswer', generateChatAnswerRequestToJson(request), options)
        .pipe(map(resp => generateChatAnswerResponseFromJson(resp)));
}
export async function getChatAnswerFunctionExecutionJob(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/GetChatAnswerFunctionExecutionJob', getChatAnswerFunctionExecutionJobRequestToJson(request));
    return getChatAnswerFunctionExecutionJobResponseFromJson(raw);
}
export function getChatAnswerFunctionExecutionJob$(request, options) {
    return defer(() => getChatAnswerFunctionExecutionJobWithTransport$(getGlobalTransport(), request, options));
}
export function getChatAnswerFunctionExecutionJobWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/GetChatAnswerFunctionExecutionJob', getChatAnswerFunctionExecutionJobRequestToJson(request), options)
        .pipe(map(resp => getChatAnswerFunctionExecutionJobResponseFromJson(resp)));
}
export async function setAssistantConnections(request) {
    await fetchRpc('ai_assistants.v1alpha1.AssistantService/SetAssistantConnections', setAssistantConnectionsRequestToJson(request));
}
export function setAssistantConnections$(request, options) {
    return defer(() => setAssistantConnectionsWithTransport$(getGlobalTransport(), request, options));
}
export function setAssistantConnectionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/SetAssistantConnections', setAssistantConnectionsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function executeFunction(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/ExecuteFunction', executeFunctionRequestToJson(request));
    return executeFunctionResponseFromJson(raw);
}
export function executeFunction$(request, options) {
    return defer(() => executeFunctionWithTransport$(getGlobalTransport(), request, options));
}
export function executeFunctionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/ExecuteFunction', executeFunctionRequestToJson(request), options)
        .pipe(map(resp => executeFunctionResponseFromJson(resp)));
}
export async function listAvailableModels(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/ListAvailableModels', listAvailableModelsRequestToJson(request));
    return listAvailableModelsResponseFromJson(raw);
}
export function listAvailableModels$(request, options) {
    return defer(() => listAvailableModelsWithTransport$(getGlobalTransport(), request, options));
}
export function listAvailableModelsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/ListAvailableModels', listAvailableModelsRequestToJson(request), options)
        .pipe(map(resp => listAvailableModelsResponseFromJson(resp)));
}
export async function listTemplateVariables(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/ListTemplateVariables', listTemplateVariablesRequestToJson(request));
    return listTemplateVariablesResponseFromJson(raw);
}
export function listTemplateVariables$(request, options) {
    return defer(() => listTemplateVariablesWithTransport$(getGlobalTransport(), request, options));
}
export function listTemplateVariablesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/ListTemplateVariables', listTemplateVariablesRequestToJson(request), options)
        .pipe(map(resp => listTemplateVariablesResponseFromJson(resp)));
}
export async function getAssistantTypeStatus(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.AssistantService/GetAssistantTypeStatus', getAssistantTypeStatusRequestToJson(request));
    return getAssistantTypeStatusResponseFromJson(raw);
}
export function getAssistantTypeStatus$(request, options) {
    return defer(() => getAssistantTypeStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getAssistantTypeStatusWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.AssistantService/GetAssistantTypeStatus', getAssistantTypeStatusRequestToJson(request), options)
        .pipe(map(resp => getAssistantTypeStatusResponseFromJson(resp)));
}
// Skipped streaming RPC: StreamingGenerateChatAnswer
// Skipped streaming RPC: ResumeStreamingGenerateChatAnswer
